jQuery.noConflict();
(function ($) {
    $(document).ready(function () {
        AOS.init({
            anchorPlacement: "top-bottom",
        });
// ---------------------------------------------------------
//  Content Links
// ---------------------------------------------------------
    $('article h5 > a').append('<em class="far fa-angle-right"></em>');

// ---------------------------------------------------------
//  FAQs
// ---------------------------------------------------------
        $('.card .collapse').on('show.bs.collapse', function () {
            var top = $('nav').outerHeight();
            $(this).parent().addClass('active');
            window.scrollTo({ top: $(this).parent().offset().top - top + 1, behavior: 'smooth' })
        })
        $('.card .collapse').on('hidden.bs.collapse', function () {
            $(this).parent().removeClass('active');
        })
// ---------------------------------------------------------
//  Carousel
// ---------------------------------------------------------
        /*$('.carousel').carousel({
            pause: false
        });*/

    });
}(jQuery));

